import { render } from "./ServicesCard.vue?vue&type=template&id=0e85751a&scoped=true"
import script from "./ServicesCard.vue?vue&type=script&lang=js"
export * from "./ServicesCard.vue?vue&type=script&lang=js"

import "./ServicesCard.vue?vue&type=style&index=0&id=0e85751a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e85751a"]])

export default __exports__